import { Component, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { VersionService } from 'src/core/version.service';
import { RumService } from './service/rum.service';

@Component({
  selector: 'lfwms-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent {
  constructor(
    private versionService: VersionService,
    private rumService: RumService
  ) {}

  ngOnInit(): void {
    this.versionService.getVersionInfo().subscribe(version => {
      console.log('Version Info:', version);
    });

    this.rumService.initRUM();
  }
}
